import React, { Fragment, useEffect } from 'react'
import FeatureDetailsModal from '../components/FeatureDetailsModal'
import ConfigurationModal from '../components/ConfigurationModal'
import ConfirmationDialog from '../../CommonComponents/confirmation_dialog/ConfirmationDialog'
import useGeoFeatures from '../hooks/useGeoFeatures'

const ModalsProvider = ({ children }: { children: React.ReactNode }) => {
    const { selectedFeature, setSelectedFeature, deleteFeature } = useGeoFeatures()

    return (
        <Fragment>
            <FeatureDetailsModal />
            <ConfigurationModal />
            {selectedFeature &&
                <ConfirmationDialog
                    type='delete'
                    open={selectedFeature?.openModal === 'delete'}
                    onCancel={() => setSelectedFeature(null)}
                    onConfirm={() => {
                        setSelectedFeature({
                            ...selectedFeature,
                            loading: true
                        })
                        deleteFeature()
                    }}
                    loading={selectedFeature?.loading}
                    title='Delete GeoFeature'
                    description={`Are you sure you want to delete ${selectedFeature?.data?.name}?`}
                    confirm_button_text='Delete'
                />
            }
            {children}
        </Fragment>
    )
}

export default ModalsProvider